/**
 * Checks if the current route is an admin route
 * @returns true if the user is on an admin route
 */
export const isAdminRoute = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  
  const pathname = window.location.pathname;
  return pathname.includes("/panel-47da9a7fba");
};
